interface TagItem {
  displayName: string;
  id: string;
  url: string | null;
}

interface HeadingMap {
  [category: string]: {
    [subCategory: string]: TagItem[];
  };
}

export const headingsToTagsMap: HeadingMap = {
  "Application UI": {
    "Application Shells": [
      {
        displayName: "Stacked Layouts",
        id: "stacked-layout",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/stacked_layouts.svg",
      },
      {
        displayName: "Sidebar Layouts",
        id: "sidebar-layout",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/sidebar_layouts.svg",
      },
      {
        displayName: "Multi-Column Layouts",
        id: "multi-column-layout",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/multi_column_layouts.svg",
      },
    ],
    Headings: [
      {
        displayName: "Page Headings",
        id: "page-heading",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/page_headings.svg",
      },
      {
        displayName: "Card Headings",
        id: "card-heading",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/card_headings.svg",
      },
      {
        displayName: "Section Headings",
        id: "section-heading",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/section_headings.svg",
      },
    ],
    "Data Display": [
      {
        displayName: "Description Lists",
        id: "description-list",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/description_lists.svg",
      },
      {
        displayName: "Stats",
        id: "stats",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/stats.svg",
      },
      {
        displayName: "Calendars",
        id: "calendar",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/calendars.svg",
      },
    ],
    Lists: [
      {
        displayName: "Stacked Lists",
        id: "stacked-list",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/stacked_lists.svg",
      },
      {
        displayName: "Tables",
        id: "table",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/tables.svg",
      },
      {
        displayName: "Grid Lists",
        id: "grid-list",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/grid_lists.svg",
      },
      {
        displayName: "Feeds",
        id: "feed",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/feeds.svg",
      },
    ],
    Forms: [
      {
        displayName: "Form Layouts",
        id: "form-layout",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/form_layouts.svg",
      },
      {
        displayName: "Input Groups",
        id: "input-group",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/input_groups.svg",
      },
      {
        displayName: "Select Menus",
        id: "select-menu",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/select_menus.svg",
      },
      {
        displayName: "Sign-in and Registration",
        id: "sign-in-and-registration",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/sign-in_and_registeration.svg",
      },
      {
        displayName: "Textareas",
        id: "textarea",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/text_areas.svg",
      },
      {
        displayName: "Radio Groups",
        id: "radio-group",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/radio_groups.svg",
      },
      {
        displayName: "Checkboxes",
        id: "checkbox",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/checkboxes.svg",
      },
      {
        displayName: "Toggles",
        id: "toggle",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/toggles.svg",
      },
      {
        displayName: "Action Panels",
        id: "action-panel",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/action_panels.svg",
      },
      {
        displayName: "Comboboxes",
        id: "combobox",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/combo_boxes.svg",
      },
    ],
    Feedback: [
      {
        displayName: "Alerts",
        id: "alert",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/alerts.svg",
      },
      {
        displayName: "Empty States",
        id: "empty-state",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/empty_states.svg",
      },
    ],
    Navigation: [
      {
        displayName: "Navbars",
        id: "navbar",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/navbars.svg",
      },
      {
        displayName: "Pagination",
        id: "pagination",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/pagination.svg",
      },
      {
        displayName: "Tabs",
        id: "tab",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/tabs.svg",
      },
      {
        displayName: "Vertical Navigation",
        id: "vertical-navigation",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/vertical_navigation.svg",
      },
      {
        displayName: "Sidebar Navigation",
        id: "sidebar-navigation",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/sidebar_navigation.svg",
      },
      {
        displayName: "Bread Crumbs",
        id: "bread-crumb",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/breadcrumbs.svg",
      },
      {
        displayName: "Progress Bars",
        id: "progress-bar",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/progress_bars.svg",
      },
      {
        displayName: "Command Palettes",
        id: "command-palette",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/command_pallettes.svg",
      },
    ],
    Overlays: [
      {
        displayName: "Modal Dialogs",
        id: "modal-dialog",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/modal_dialogs.svg",
      },
      {
        displayName: "Drawers",
        id: "drawer",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/drawers.svg",
      },
      {
        displayName: "Notifications",
        id: "notification",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/notifications.svg",
      },
    ],
    Elements: [
      {
        displayName: "Avatars",
        id: "avatar",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/avatars.svg",
      },
      {
        displayName: "Badges",
        id: "badge",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/badges.svg",
      },
      {
        displayName: "Dropdowns",
        id: "dropdown",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/dropdowns.svg",
      },
      {
        displayName: "Buttons",
        id: "button",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/buttons.svg",
      },
      {
        displayName: "Button Groups",
        id: "button-group",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/button_groups.svg",
      },
    ],
    Layout: [
      {
        displayName: "Containers",
        id: "container",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/containers.svg",
      },
      {
        displayName: "Cards",
        id: "card",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/cards.svg",
      },
      {
        displayName: "List Containers",
        id: "list-container",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/list_containers.svg",
      },
      {
        displayName: "Media Objects",
        id: "media-object",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/media_objects.svg",
      },
      {
        displayName: "Dividers",
        id: "divider",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/dividers.svg",
      },
    ],
    "Page Examples": [
      {
        displayName: "Home Screens",
        id: "home-screen",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/home_screens.svg",
      },
      {
        displayName: "Detail Screens",
        id: "detail-screen",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/details_screens.svg",
      },
      {
        displayName: "Settings Screens",
        id: "settings-screen",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/settings_screens.svg",
      },
    ],
  },
  "Marketing UI": {
    "Page Sections": [
      {
        displayName: "Hero Sections",
        id: "hero-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/hero_sections.svg",
      },
      {
        displayName: "Feature Sections",
        id: "feature-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/feature_sections.svg",
      },
      {
        displayName: "CTA Sections",
        id: "cta-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/CTA_sections.svg",
      },
      {
        displayName: "Bento Grids",
        id: "bento-grid",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/bento_grids.svg",
      },
      {
        displayName: "Pricing Sections",
        id: "pricing-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/pricing_sections-1.svg",
      },
      {
        displayName: "Header Sections",
        id: "header-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/header_sections-1.svg",
      },
      {
        displayName: "Newsletter Sections",
        id: "newsletter-section",
        url: null,
      },
      {
        displayName: "Stats",
        id: "stats",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/stats.svg",
      },
      {
        displayName: "Testimonials",
        id: "testimonial",
        url: null,
      },
      {
        displayName: "Blog Sections",
        id: "blog-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/blog_sections.svg",
      },
      {
        displayName: "Contact Sections",
        id: "contact-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/contact_sections.svg",
      },
      {
        displayName: "Team Sections",
        id: "team-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/team_sections.svg",
      },
      {
        displayName: "Content Sections",
        id: "content-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/content_sections.svg",
      },
      {
        displayName: "Logo Clouds",
        id: "logo-cloud",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/logo_clouds.svg",
      },
      {
        displayName: "FAQs",
        id: "faq",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/FAQ.svg",
      },
      {
        displayName: "Footers",
        id: "footer",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/footers.svg",
      },
    ],
    Elements: [
      {
        displayName: "Headers",
        id: "header",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/headers.svg",
      },
      {
        displayName: "Flyout Menus",
        id: "flyout-menu",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/flyout_menus.svg",
      },
      {
        displayName: "Banners",
        id: "banner",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/banners.svg",
      },
    ],
    Feedback: [
      {
        displayName: "404 Pages",
        id: "404-page",
        url: null,
      },
    ],
    "Page Examples": [
      {
        displayName: "Landing Pages",
        id: "landing-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/landing_pages.svg",
      },
      {
        displayName: "Pricing Pages",
        id: "pricing-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/pricing_pages.svg",
      },
      {
        displayName: "About Pages",
        id: "about-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/about_pages.svg",
      },
    ],
  },
  "E-commerce UI": {
    Components: [
      {
        displayName: "Product Overviews",
        id: "product-overview",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/product_overviews.svg",
      },
      {
        displayName: "Product Lists",
        id: "product-list",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/product_lists.svg",
      },
      {
        displayName: "Category Previews",
        id: "category-preview",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/category_previews.svg",
      },
      {
        displayName: "Shopping Carts",
        id: "shopping-cart",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/shopping_carts.svg",
      },
      {
        displayName: "Category Filters",
        id: "category-filter",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/category_filters.svg",
      },
      {
        displayName: "Product Quickviews",
        id: "product-quickview",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/product_quickviews.svg",
      },
      {
        displayName: "Product Features",
        id: "product-feature",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/product_features.svg",
      },
      {
        displayName: "Store Navigation",
        id: "store-navigation",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/store_navigation.svg",
      },
      {
        displayName: "Promo Sections",
        id: "promo-section",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/promo_sections.svg",
      },
      {
        displayName: "Checkout Forms",
        id: "checkout-form",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/checkout_forms.svg",
      },
      {
        displayName: "Reviews",
        id: "review",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/reviews.svg",
      },
      {
        displayName: "Order Summaries",
        id: "order-summary",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/order_summaries.svg",
      },
      {
        displayName: "Order History",
        id: "order-history",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/order_history.svg",
      },
      {
        displayName: "Incentives",
        id: "incentive",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/incentives.svg",
      },
    ],
    "Page Examples": [
      {
        displayName: "Storefront Pages",
        id: "storefront-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/storefront_pages.svg",
      },
      {
        displayName: "Product Pages",
        id: "product-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/product_pages.svg",
      },
      {
        displayName: "Category Pages",
        id: "category-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/category_pages.svg",
      },
      {
        displayName: "Shopping Cart Pages",
        id: "shopping-cart-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/shopping_cart_pages.svg",
      },
      {
        displayName: "Checkout Pages",
        id: "checkout-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/checkout_pages.svg",
      },
      {
        displayName: "Order Detail Pages",
        id: "order-detail-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/order_detail_pages.svg",
      },
      {
        displayName: "Order History Pages",
        id: "order-history-page",
        url: "https://storage.googleapis.com/tempo-image-previews/thumbnails/order_history_pages.svg",
      },
    ],
  },
};

// Helper function to get all categories
export const getAllCategories = () => {
  return Object.keys(headingsToTagsMap);
};

// Helper function to get all subcategories for a category
export const getSubcategoriesByCategory = (category: string) => {
  return Object.keys(headingsToTagsMap[category] || {});
};

// Helper function to get all items for a subcategory in a category
export const getItemsBySubcategory = (
  category: string,
  subcategory: string
) => {
  return headingsToTagsMap[category]?.[subcategory] || [];
};

// Helper function to get all items flattened for a category
export const getAllItemsForCategory = (category: string) => {
  const result: TagItem[] = [];
  const subcategories = getSubcategoriesByCategory(category);

  subcategories.forEach((subcategory) => {
    result.push(...getItemsBySubcategory(category, subcategory));
  });

  return result;
};

// Get a flat list of all items
export const getAllItems = () => {
  const result: TagItem[] = [];
  const categories = getAllCategories();

  categories.forEach((category) => {
    result.push(...getAllItemsForCategory(category));
  });

  return result;
};

// Get subcategories with their counts
export const getCategoriesWithCounts = () => {
  return getAllCategories().map((category) => {
    const subcategories = getSubcategoriesByCategory(category);
    const itemCount = getAllItemsForCategory(category).length;

    return {
      category,
      subcategories,
      itemCount,
    };
  });
};
